import { Component, Inject, inject, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { Account, tiers } from '../../../../../../service/account.service';
import { MatSelectModule } from '@angular/material/select';
import { KeyValuePipe } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AdminService } from '../../../../../../service/admin.service';

@Component({
  selector: 'app-edit-user-patreon',
  imports: [
    MatDialogModule, 
    MatButtonModule, 
    MatListModule, 
    MatFormFieldModule, 
    MatInputModule,
    FormsModule,
    MatSelectModule,
    KeyValuePipe,
    MatCheckboxModule
  ],
  templateUrl: './edit-user-patreon.component.html',
  styleUrl: './edit-user-patreon.component.less'
})
export class EditUserPatreonComponent {
  dialog = inject(MatDialog);
  private dialogRef = inject(MatDialogRef);
  adminService = inject(AdminService);
  tiers = tiers;
  
  data?: Account;
  
  @Output() userUpdated = new EventEmitter<Account>();
  get selectedTierId() {
    return this.data?.connections.patreon?.subscriptionTier?.id.toString() || "-1";
  };

  set selectedTierId(value: string) {
    if (this.data?.connections.patreon) {
      this.data.connections.patreon.subscriptionTier = this.tiers[value];
    }
  }

  constructor (
    @Inject(MAT_DIALOG_DATA) private _data: { user: Account }
  ) {
    this.data = structuredClone(this._data.user);
    
    // Ensure patreon connection exists for editing
    if (!this.data.connections.patreon) {
      this.data.connections.patreon = {
        id: '',
        username: '',
        avatar: '',
        subscriptionTier: this.tiers['-1'],
        overridden: false,
        email: '',
        expire: '',
        connected_at: ''
      };
    }
    
    console.log(this.data);
  }

  onTierChange(tierId: string) {
    if (this.data?.connections.patreon) {
      this.data.connections.patreon.subscriptionTier = this.tiers[tierId];
    }
  }

  save() {
    if (this.data) {
      this.adminService.patchUser(this.data).subscribe((data: any) => {
        console.log(data);
        if (data.code == 200) {
          // Emit the updated user data to the parent
          this.userUpdated.emit(this.data);
          this.dialogRef.close();
        } else {
          alert(data.message);
        } 
      });
    } else {
      alert("Something went wrong")
    }
  }
}
